import {useContext} from 'react'

import { ShowFileModalFormWrapper } from './ShowFileModalFormWrapper'
import { ShowFileModalHeader } from './ShowFileModalHeader'
import { DocumentsReportContext } from '../DocumentsReportContext'

const ShowFileModal = () => {

  const {showFileModal} = useContext(DocumentsReportContext)

  return (
    <>
      {showFileModal && (
        <>
          <div>
            <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true' style={{zIndex: 2000}}>
              {/* begin::Modal dialog */}
              <div className='modal-dialog modal-dialog-centered modal-xl'>
                {/* begin::Modal content */}
                <div className='modal-content'>
                  <ShowFileModalHeader />
                  {/* begin::Modal body */}
                  <div className='modal-body scroll-y  my-2'>
                    <ShowFileModalFormWrapper />
                  </div>
                  {/* end::Modal body */}
                </div>
                {/* end::Modal content */}
              </div>
              {/* end::Modal dialog */}
            </div>
          </div>
          {/* begin::Modal Backdrop */}
          <div className='modal-backdrop fade show'></div>
          {/* end::Modal Backdrop */}
        </>
      )}
    </>
  )
}

export {ShowFileModal}
